import BasketKP from "components/BasketKP";
import ExperienceBuilderEG from "components/ExperienceBuilderEG";
import { lazy } from "react";

const Calendar = lazy(() => import("./components/Calendar"));
const EventSearch = lazy(() => import("./components/EventSearch"));
const Blog = lazy(() => import("./components/Blog"));
const BlogEG = lazy(() => import("./components/BlogEG"));
const BlogLyvera = lazy(() => import("./components/BlogLyvera"));
const Playground = lazy(() => import("./components/Playground"));
const MyBookingsEG = lazy(() => import("./components/MyBookingsEG"));
const MyBookingsCalendar = lazy(
  () => import("./components/MyBookingsCalendar"),
);
const PaymentHistoryEG = lazy(() => import("./components/PaymentHistoryEG"));
const RoomBookingEG = lazy(() => import("./components/RoomBookingEG"));
const PackageRoomListingEG = lazy(
  () => import("./components/PackageRoomListingEG"),
);
const ExperienceSearchEG = lazy(
  () => import("./components/ExperienceSearchEG"),
);
const ExperienceListEG = lazy(() => import("./components/ExperienceListEG"));
const BasketEG = lazy(() => import("./components/BasketEG"));
const BasketTEG = lazy(() => import("./components/BasketTEG"));
const Fixtures = lazy(() => import("./components/Fixtures"));
const FixtureMultiDay = lazy(() => import("./components/FixtureMultiDay"));
const OrderHistoryKP = lazy(() => import("./components/OrderHistoryKP"));
const OrderHistoryTEG = lazy(() => import("./components/OrderHistoryTEG"));
const OrderGuestDetailsKP = lazy(() => import("./components/OrderGuestDetailsKP"));
const HomepageSearchKP = lazy(() => import("./components/HomepageSearchKP"));
const SearchResultsKP = lazy(() => import("./components/SearchResultsKP"));
const GiftVoucher = lazy(() => import("./components/GiftVoucher"));
const GiftVoucherOrderHistory = lazy(
  () => import("./components/GiftVoucherOrderHistory"),
);

export const DOM_ELEMENT_CLASS = "react-component";
export const DOM_ELEMENT_ID = "react-component";

export enum Components {
  Calendar = "Calendar",
  EventSearch = "EventSearch",
  Blog = "Blog",
  BlogEG = "BlogEG",
  BlogLyvera = "BlogLyvera",
  BasketEG = "BasketEG",
  BasketTEG = "BasketTEG",
  Playground = "Playground",
  Fixtures = "Fixtures",
  FixtureMultiDay = "FixtureMultiDay",
  MyBookingsEG = "MyBookingsEG",
  PaymentHistoryEG = "PaymentHistoryEG",
  RoomBookingEG = "RoomBookingEG",
  PackageRoomListingEG = "PackageRoomListingEG",
  ExperienceListEG = "ExperienceListEG",
  ExperienceSearchEG = "ExperienceSearchEG",
  ExperienceBuilderEG = "TailoredExperience",
  MyBookingsCalendar = "MyBookingsCalendar",
  BasketKP = "BasketKP",
  OrderHistoryKP = "OrderHistoryKP",
  OrderHistoryTEG = "OrderHistoryTEG",
  OrderGuestDetailsKP = "OrderGuestDetailsKP",
  HomepageSearchKP = "HomepageSearchKP",
  SearchResultsKP = "SearchResultsKP",
  GiftVoucher = "GiftVoucher",
  GiftVoucherOrderHistory = "GiftVoucherOrderHistory",
}

export enum STYLES {
  KP = "KP",
  EG = "EG",
}

export const COMPONENT_MAP = {
  [Components.Calendar]: Calendar,
  [Components.EventSearch]: EventSearch,
  [Components.Blog]: Blog,
  [Components.Playground]: Playground,
  [Components.MyBookingsCalendar]: MyBookingsCalendar,
  [Components.BlogEG]: BlogEG,
  [Components.BlogLyvera]: BlogLyvera,
  [Components.MyBookingsEG]: MyBookingsEG,
  [Components.PaymentHistoryEG]: PaymentHistoryEG,
  [Components.RoomBookingEG]: RoomBookingEG,
  [Components.PackageRoomListingEG]: PackageRoomListingEG,
  [Components.ExperienceSearchEG]: ExperienceSearchEG,
  [Components.ExperienceListEG]: ExperienceListEG,
  [Components.BasketEG]: BasketEG,
  [Components.BasketTEG]: BasketTEG,
  [Components.Fixtures]: Fixtures,
  [Components.ExperienceBuilderEG]: ExperienceBuilderEG,
  [Components.FixtureMultiDay]: FixtureMultiDay,
  [Components.BasketKP]: BasketKP,
  [Components.OrderHistoryKP]: OrderHistoryKP,
  [Components.OrderHistoryTEG]: OrderHistoryTEG,
  [Components.OrderGuestDetailsKP]: OrderGuestDetailsKP,
  [Components.HomepageSearchKP]: HomepageSearchKP,
  [Components.SearchResultsKP]: SearchResultsKP,
  [Components.GiftVoucher]: GiftVoucher,
  [Components.GiftVoucherOrderHistory]: GiftVoucherOrderHistory,
};
